import { MerchantAppReturnZodSchema } from "@redotech/redo-return-core-common/return";
import * as z from "zod";

export const getReturnsForOrder = {
  name: "getReturnsForOrder" as const,
  input: z.object({ orderId: z.string() }),
  output: z.array(MerchantAppReturnZodSchema),
};
